import styled from 'styled-components';

export const PartnerText = styled.span`
  white-space: pre-line;
  overflow-wrap: anywhere;
`;

export const Rows = styled.div`
  display: grid;
  grid-template-columns: minmax(0, max-content) 1fr;
  gap: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
`;

export const RowLabel = styled.span`
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
